import { z } from 'zod';
import api from '../axiosConfig';

export const businessOnlineEnquirySchema = z.object({
    reg1: z.string().optional(),
    reg2: z.string().optional(),
    reg3: z.string().optional(),
    businessName: z.string().optional(),
    vatNo: z.string().optional(),
    solePropIdNo: z.string().optional(),
    yourReference: z.string().optional(),
    voucherCode: z.string().optional(),
});

export type BusinessOnlineEnquiryPayload = z.infer<typeof businessOnlineEnquirySchema>;

// Typed contract owned by us — mirrors BusinessMatchItem Pydantic schema
export interface BusinessMatchItem {
    commercial_id: string | null;
    registration_no: string | null;
    business_name: string | null;
    enquiry_id: string;
    enquiry_result_id: string;
    reference: string | null;
}

export interface BusinessMatchResponse {
    success: boolean;
    message: string;
    log_id: string;
    matches: BusinessMatchItem[];
}

export interface BusinessOnlineEnquiryResultPayload {
    enquiryId: number;
    enquiryResultId: number;
    yourReference?: string;
    voucherCode?: string;
}

const MATCH_URL = '/verification/business-enquiry/match';
const RESULT_URL = '/verification/business-enquiry/result';

export const businessOnlineEnquiryService = {
    getMatch: async (payload: BusinessOnlineEnquiryPayload): Promise<BusinessMatchResponse> => {
        try {
            const response = await api.post(MATCH_URL, payload);
            return response.data;
        } catch (error) {
            console.error('API Error during Business Match:', error);
            throw error;
        }
    },

    getResult: async (payload: BusinessOnlineEnquiryResultPayload) => {
        try {
            const response = await api.post(RESULT_URL, payload);
            return response.data;
        } catch (error) {
            console.error('API Error during Business Result:', error);
            throw error;
        }
    }
};
